import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { auth, authLoading } = useAuth();
  if (authLoading) {
    return; // or null or skeleton
  }
  return auth.token ? children : <Navigate to="/" />; // default page to redirect to if not authenticated
};

export default PrivateRoute;
